/* Custom wishlist page. Gets the list from Swym (_swat.fetch) then enriches each
   item with Shopify product data (/products/<handle>.js) to render the card,
   total value, and pagination. Requires the Swym app embed (loads SwymCallbacks). */
(function () {
  var root = document.querySelector('[data-wishlist-root]');
  if (!root) return;
  var cfg = window.__wishlistPage || {};
  var perPage = cfg.perPage || 8;

  var gridEl = root.querySelector('[data-wl-grid]');
  var countEl = root.querySelector('[data-wl-count]');
  var totalEl = root.querySelector('[data-wl-total]');
  var pagEl = root.querySelector('[data-wl-pagination]');
  var loadingEl = root.querySelector('[data-wl-loading]');
  var emptyEl = root.querySelector('[data-wl-empty]');

  var entries = [];   // { empi, epi, du, product, variant }
  var page = 1;

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
  function money(cents, noDecimals) {
    var v = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency,
        minimumFractionDigits: noDecimals ? 0 : 2,
        maximumFractionDigits: noDecimals ? 0 : 2
      }).format(v);
    } catch (e) { return v.toFixed(noDecimals ? 0 : 2); }
  }

  function handleFromDu(du) {
    try { var m = String(du).split('?')[0].split('#')[0].match(/\/products\/([^\/]+)/); return m ? m[1] : null; }
    catch (e) { return null; }
  }

  var HEART = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20.3l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 5 3.98 3 6.5 3 8 3 9.44 3.72 10.36 4.86L12 6.9l1.64-2.04A4.4 4.4 0 0 1 17.5 3C20.02 3 22 5 22 7.5c0 3.78-3.4 6.86-8.55 11.49z"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>';
  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m-8 0 1 13h8l1-13"/></svg>';
  var COMPARE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 8h13l-3-3m6 11H7l3 3"/></svg>';
  var FLAME = '<svg viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M6.6.75c.3 1.5-.45 2.4-1.2 3.15-.75.75-1.5 1.5-1.5 2.85a3.1 3.1 0 0 0 6.2 0c0-1.8-1.35-3.3-2.4-4.5-.3-.45-.75-1.05-1.1-1.5Z"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* The theme's real product placeholder art. `placeholder_svg_tag` is Liquid-only, so
     the section renders it once into a <template> and it is cloned from here - same
     artwork snippets/fresh-card.liquid falls back to. */
  var PLACEHOLDER = (function () {
    var tpl = document.querySelector('[data-wl-placeholder]');
    return tpl ? tpl.innerHTML.trim() : '';
  })();
  function placeholderHtml() { return '<div class="ct__img ct__img--placeholder">' + PLACEHOLDER + '</div>'; }

  /* Seatbelt for the fetch below. If anything ever makes Shopify answer with its native
     product JSON instead of the wishlist-card view, salvage the fields that mean the
     same thing in both shapes rather than rendering a blank card. Stock and colour have
     no equivalent there, so they keep their defaults. */
  function nativeJsonFallback(data) {
    if (!data || !data.product || data.featured_image !== undefined) return data;
    if (window.console) console.warn('wishlist: got Shopify native product JSON instead of ?view=wishlist-card - enrichment degraded.');
    var p = data.product;
    var variants = {};
    (p.variants || []).forEach(function (v) {
      variants[v.id] = {
        price: Math.round((parseFloat(v.price) || 0) * 100),
        compare_at: Math.round((parseFloat(v.compare_at_price) || 0) * 100),
        available: true,
        image: (v.featured_image && v.featured_image.src) || '',
        color: '', color_image: ''
      };
    });
    return {
      title: p.title, vendor: p.vendor, handle: p.handle, variants: variants,
      featured_image: (p.image && (p.image.src || p.image)) ||
        (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
      labels: [], siblings: []
    };
  }

  function colorStyle(e) {
    if (e.color) return ' style="background:' + esc(e.color) + '"';
    if (e.color_image) return ' style="background-image:url(' + esc(e.color_image) + ');background-size:cover"';
    return '';
  }

  function cardHtml(e) {
    var available = e.available !== false;
    var stockCls = available ? 'in' : 'out';
    var stockTxt = available ? (cfg.inStock || 'In stock') : (cfg.outStock || 'Out of stock');
    var hasBrand = !!e.brand;
    var hasBrandLogo = !!(e.brand_logo);
    var hasColor = !!(e.color || e.color_image);

    return '' +
      /* Class names here are deliberately the SAME ones snippets/fresh-card.liquid
         emits on the home page. Their styling lives once, globally, in theme.css
         (80 `.ct__*` rules), so the wishlist card and the home card cannot drift
         apart - there is no second copy of the CSS to keep in sync. Only the
         actions row below (.wl-card__actions) is wishlist-specific. */
      '<div class="ct__card' + (available ? '' : ' ct__card--soldout') + '" data-empi="' + esc(e.empi) + '" data-epi="' + esc(e.epi) + '" data-du="' + esc(e.du) + '">' +

        /* Media - ct__media pattern */
        '<div class="ct__media">' +
          '<a class="ct__media-link" href="' + esc(e.du) + '" aria-label="' + esc(e.code) + '">' +
            (e.image
              ? '<img class="ct__img" src="' + esc(e.image) + '" alt="' + esc(e.code) + '" loading="lazy">'
              : placeholderHtml()) +
          '</a>' +

          /* Heart - ct__iconbtn ct__wish style (filled, since items are in wishlist) */
          /* Two hearts, matching fresh-card: the global CSS swaps fill/line by
             state, and this section forces the filled one - every item here is
             already saved, so an outline heart would be misleading. */
          '<button type="button" class="ct__iconbtn ct__wish is-active" data-wl-remove aria-label="' + esc(cfg.remove || 'Remove') + '">' +
            '<span class="ct__heart-fill">' + HEART + '</span>' +
            '<span class="ct__heart-line">' + HEART + '</span>' +
          '</button>' +

          /* Badges - product_badge metaobjects, same source as product-badges.liquid.
             text_color and icon are supplied by the wishlist-card view; both are
             optional, so a legacy theme.label badge (colour only) still renders. The
             hardcoded FLAME is the fallback when a badge has no icon uploaded. */
          (e.labels && e.labels.length
            ? '<div class="ct__labels">' + e.labels.map(function (l) {
                var css = '';
                if (l.color) css += 'background:' + esc(l.color) + ';';
                if (l.text_color) css += 'color:' + esc(l.text_color) + ';';
                var style = css ? ' style="' + css + '"' : '';
                var glyph = l.icon
                  ? '<img class="ct__badge-icon" src="' + esc(l.icon) + '" alt="" width="14" height="14">'
                  : FLAME;
                return '<span class="ct__badge"' + style + '>' + glyph + '<span>' + esc(l.text) + '</span></span>';
              }).join('') + '</div>'
            : '') +

          /* Quick-add pill over the media, per the Figma. Reuses the same
             [data-wl-add] hook as the Add to Bag button below - one code path. */
          (available
            ? '<button type="button" class="ct__qa-btn" data-wl-add>' + esc(cfg.quickAdd || 'Add to cart') + '</button>'
            : '') +

          /* Compare - compare.js binds on [data-compare-handle] delegated at document level */
          (e.handle
            ? '<button type="button" class="ct__iconbtn ct__compare" data-compare-handle="' + esc(e.handle) + '" aria-pressed="false" aria-label="Compare">' + COMPARE + '</button>'
            : '') +

        '</div>' +

        /* Info - ct__info pattern */
        '<div class="ct__info">' +
          /* Meta row - brand left, stock right, sitting above the title. */
          '<div class="ct__meta">' +
            (hasBrand
              ? '<a class="ct__brand" href="' + esc(e.du) + '">' +
                  (hasBrandLogo ? '<img class="ct__brand-logo" src="' + esc(e.brand_logo) + '" width="24" height="24" alt="" loading="lazy">' : '') +
                  '<span class="ct__brand-name">' + esc(e.brand) + '</span></a>'
              : '<span></span>') +
            '<span class="ct__stock ct__stock--' + stockCls + '"><span class="ct__dot"></span><span>' + esc(stockTxt) + '</span></span>' +
          '</div>' +

          /* Product title - same .ct__title as the home card */
          '<a class="ct__title" href="' + esc(e.du) + '">' + esc(e.code) + '</a>' +

          /* Swatches - every distinct variant colour, saved one marked current */
          (e.swatches && e.swatches.length
            ? '<span class="ct__swatches">' + e.swatches.map(function (s) {
                var isImg = !s.color && s.color_image;
                var cls = 'ct__swatch' + (isImg ? ' ct__swatch--img' : '') + (s.current ? ' is-active' : '');
                var label = esc(s.title || '');
                /* An <a> with no children is caught by the theme's global
                   `a:empty { display: none }` reset - hence the sr-only span.
                   Same guard fresh-card.liquid uses. */
                return s.url
                  ? '<a class="' + cls + '" href="' + esc(s.url) + '" data-tip="' + label + '" aria-label="' + label + '"' + colorStyle(s) + '><span class="sr-only">' + label + '</span></a>'
                  : '<span class="' + cls + '"' + colorStyle(s) + '></span>';
              }).join('') + '</span>'
            : (hasColor ? '<span class="ct__swatches"><span class="ct__swatch is-active"' + colorStyle(e) + '></span></span>' : '')) +

          /* Price - current, plus compare-at struck through when genuinely higher */
          '<div class="ct__price">' +
            '<span class="ct__now">' + money(e.price) + '</span>' +
            (e.compare_at ? '<span class="ct__was">' + money(e.compare_at) + '</span>' : '') +
          '</div>' +
        '</div>' +

        /* Actions row - unique to wishlist (add to bag + remove) */
        '<div class="wl-card__actions">' +
          '<button type="button" class="wl-card__bag" data-wl-add' + (available ? '' : ' disabled') + '>' + BAG + '<span>' + esc(cfg.addToBag || 'Add to Bag') + '</span></button>' +
          '<button type="button" class="wl-card__remove" data-wl-remove>' + TRASH + '<span>' + esc(cfg.remove || 'Remove') + '</span></button>' +
        '</div>' +
      '</div>';
  }

  function renderPagination(pages) {
    if (pages <= 1) { pagEl.hidden = true; pagEl.innerHTML = ''; return; }
    pagEl.hidden = false;
    var out = [];
    out.push('<button type="button" class="wl__page" data-wl-goto="' + (page - 1) + '"' + (page === 1 ? ' disabled' : '') + ' aria-label="Previous">&lsaquo;</button>');
    var nums = [];
    for (var i = 1; i <= pages; i++) {
      if (i === 1 || i === pages || (i >= page - 1 && i <= page + 1)) nums.push(i);
      else if (nums[nums.length - 1] !== '...') nums.push('...');
    }
    nums.forEach(function (n) {
      if (n === '...') { out.push('<span class="wl__page wl__page--ellipsis">…</span>'); }
      else { out.push('<button type="button" class="wl__page" data-wl-goto="' + n + '"' + (n === page ? ' aria-current="true"' : '') + '>' + n + '</button>'); }
    });
    out.push('<button type="button" class="wl__page" data-wl-goto="' + (page + 1) + '"' + (page === pages ? ' disabled' : '') + ' aria-label="Next">&rsaquo;</button>');
    pagEl.innerHTML = out.join('');
  }

  function render() {
    if (loadingEl) loadingEl.hidden = true;
    countEl.textContent = entries.length;
    var totalCents = entries.reduce(function (sum, e) {
      return sum + (parseInt(e.price, 10) || 0);
    }, 0);
    totalEl.textContent = money(totalCents, true);

    if (!entries.length) {
      gridEl.querySelectorAll('.ct__card').forEach(function (n) { n.remove(); });
      if (emptyEl) emptyEl.hidden = false;
      renderPagination(0);
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    var pages = Math.ceil(entries.length / perPage);
    if (page > pages) page = pages;
    var slice = entries.slice((page - 1) * perPage, page * perPage);
    gridEl.querySelectorAll('.ct__card').forEach(function (n) { n.remove(); });
    gridEl.insertAdjacentHTML('beforeend', slice.map(cardHtml).join(''));
    bindImageFallbacks();
    renderPagination(pages);
  }

  /* An item's image URL can also come from Swym, captured when it was saved - if that
     file was since replaced or deleted the <img> 404s. Show the placeholder rather than
     the browser's broken-image glyph. */
  function bindImageFallbacks() {
    gridEl.querySelectorAll('img.ct__img').forEach(function (img) {
      if (img.__wlBound) return;
      img.__wlBound = true;
      var swap = function () {
        if (!img.parentNode) return;
        var ph = document.createElement('div');
        ph.className = 'ct__img ct__img--placeholder';
        ph.innerHTML = PLACEHOLDER;
        img.parentNode.replaceChild(ph, img);
      };
      img.addEventListener('error', swap, { once: true });
      if (img.complete && img.naturalWidth === 0) swap();
    });
  }

  function enrich(items) {
    var cache = {};
    return Promise.all(items.map(function (it) {
      var handle = handleFromDu(it.du);
      var base = {
        empi: it.empi, epi: it.epi, du: it.du,
        code: it.dt || '', brand: '', brand_logo: '', image: it.iu || '',
        price: (it.pr != null ? Math.round(parseFloat(it.pr) * 100) : null),
        available: true, color: '', color_image: '',
        compare_at: 0, labels: [], swatches: [], handle: handle
      };
      if (!handle) return Promise.resolve(base);
      /* Deliberately NO `Accept: application/json` header. Shopify content-negotiates
         on it: with that header the storefront ignores `?view=` entirely and answers
         with its own {"product":{…}} payload, so every field read below is undefined
         and the card silently degrades to whatever Swym cached - usually no image at
         all. The custom view replies as text/html; r.json() parses it regardless. */
      var pr = cache[handle] || (cache[handle] = fetch('/products/' + handle + '?view=wishlist-card')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(nativeJsonFallback)
        .catch(function () { return null; }));
      return pr.then(function (data) {
        if (!data) return base;
        var v = (data.variants && data.variants[it.epi]) || null;
        base.code = data.title || base.code;
        base.brand = data.brand || data.vendor || '';
        base.brand_logo = data.brand_logo || '';
        base.image = (v && v.image) || data.featured_image || base.image;
        base.price = v ? v.price : base.price;
        base.available = v ? v.available : (data.available !== false);
        base.color = (v && v.color) || data.product_color || '';
        base.color_image = (v && v.color_image) || '';
        base.handle = data.handle || base.handle;
        base.labels = Array.isArray(data.labels) ? data.labels : [];

        /* Compare-at only counts when it is genuinely higher than the price,
           otherwise Shopify's leftover values render a nonsense strikethrough. */
        var cmp = v ? v.compare_at : 0;
        base.compare_at = (cmp && base.price && cmp > base.price) ? cmp : 0;

        /* Variations, in the same precedence snippets/fresh-card.liquid uses on
           the home page:
             1. custom.variation_products siblings - how this catalogue actually
                models colour (separate products, not variants)
             2. failing that, the product's own variant colours
           Reading variants alone produced a single swatch on nearly every card. */
        var seen = {};
        if (Array.isArray(data.siblings) && data.siblings.length) {
          data.siblings.forEach(function (sib) {
            var thumb = sib.image || '';
            var key = sib.color || thumb || sib.url;
            if (!key || seen[key]) return;
            seen[key] = true;
            base.swatches.push({
              color: sib.color,
              color_image: thumb,
              url: sib.url,
              title: sib.title,
              current: !!sib.self
            });
          });
        } else {
          Object.keys(data.variants || {}).forEach(function (id) {
            var vv = data.variants[id];
            var thumb = vv.color_image || vv.image || '';
            var key = vv.color || thumb;
            if (!key || seen[key]) return;
            seen[key] = true;
            /* Key must be `color_image`, not `image` - colorStyle() reads that name. */
            base.swatches.push({ color: vv.color, color_image: thumb, current: String(id) === String(it.epi) });
          });
        }

        return base;
      });
    }));
  }

  function addToBag(card) {
    var epi = card.getAttribute('data-epi');
    var btn = card.querySelector('[data-wl-add]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(epi, 10), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      if (cfg.onAdd === 'cart') { window.location.href = '/cart'; return; }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var opener = document.querySelector('[aria-controls="CartDrawer"]');
      if (opener) { opener.click(); } else { window.location.href = '/cart'; }
      if (btn) btn.disabled = false;
    }).catch(function () { if (btn) btn.disabled = false; window.location.href = '/cart'; });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    var lid = null;
    swat.fetchLists({
      callbackFn: function (lists) { lid = (lists && lists[0] && lists[0].lid) || null; },
      errorFn: function () {}
    });

    function load() {
      swat.fetch(function (items) {
        enrich(items || []).then(function (res) { entries = res; page = 1; render(); });
      }, function () { if (loadingEl) loadingEl.textContent = 'Could not load your wishlist.'; });
    }
    load();

    gridEl.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.ct__card');
      if (!card) return;
      if (e.target.closest('[data-wl-add]')) { addToBag(card); return; }
      if (e.target.closest('[data-wl-remove]')) {
        if (!lid) return;
        var product = { empi: parseInt(card.getAttribute('data-empi'), 10), epi: parseInt(card.getAttribute('data-epi'), 10), du: card.getAttribute('data-du') };
        card.style.opacity = '0.5';
        swat.deleteFromList(lid, product, function () {
          entries = entries.filter(function (x) { return String(x.epi) !== String(product.epi); });
          render();
        }, function () { card.style.opacity = ''; });
      }
    });

    pagEl.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-wl-goto]');
      if (!btn || btn.disabled) return;
      var n = parseInt(btn.getAttribute('data-wl-goto'), 10);
      if (n >= 1) { page = n; render(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
    });
  });
})();
